import { render, staticRenderFns } from "./declaracoes.vue?vue&type=template&id=e0d38580&"
import script from "./declaracoes.vue?vue&type=script&lang=js&"
export * from "./declaracoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports